export default __webpack_public_path__ + "static/media/bakerHealth-stack1.webp";